import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BreadScrumb from "../components/BreadScrumb";
import { Link } from "react-router-dom";

const AtYourDoorStore = () => {
  return (
    <div>
      <Header />
      <div id="content" className="no-top no-bottom">
        <BreadScrumb
          title="At Your Door Store"
          Banner="/assets/images/background/3.webp"
        />

        <div className="container my-4">
          <h3 className="mb-4" style={{ color: "#73b734" }}>
            Our Exclusive Stores
          </h3>
          <div className="row">
            {/* First Store */}
            <div className="col-md-3">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <span
                    className="badge text-white"
                    style={{ backgroundColor: "#73b734" }}
                  >
                    Open Now
                  </span>
                  <h5 className="mt-2" style={{ color: "#73b734" }}>
                    At Your Door Mobile Repair Shop
                  </h5>
                  <p>Gaitor Road, Jagatpura, Jaipur, Rajasthan-302017</p>
                  <p>
                    <strong>Timings:</strong> 10:00 AM - 09:00 PM
                  </p>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-sm text-white"
                      style={{
                        backgroundColor: "#73b734",
                        height: "35px",
                        width: "100px",
                      }}
                    >
                      <i className="fas fa-phone-alt"></i> Call Store
                    </button>
                    <Link
                      to="/contact"
                      className="btn btn-outline-success btn-sm"
                      style={{
                        borderColor: "#73b734",
                        color: "#73b734",
                        height: "35px",
                        width: "125px",
                      }}
                    >
                      <i className="fas fa-map-marker-alt"></i> Get Directions
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AtYourDoorStore;
